import React, { useEffect, useState } from 'react'
import { Box, Button, Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material'
import { Item } from '../../../../common/snippets'
import moment from 'moment'
import Datepicker from '../../../../common/datePicker'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { focusElemnt, isEmpty, jsPdfDidParseCellCallback, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import DropDownOA from '../../../../common/dropDownOA'
import { getColumnDefs, tab1Data, getColumnDefsOneFilter, getColumnDefsForGrouping } from './constants'
import { useTranslation } from '../../../../../i18n/I18nProvider'
import TablePaginationCustom from '../../../../common/TablePagination'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { updateAlertError, updateLoader } from '../../../../../store/common/common_action'
import { connect } from 'react-redux'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { callAddFontRobotoBold } from '../../../../common/font/font/Roboto-bold';
import { callAddFontRobotoMedium } from '../../../../common/font/font/Roboto-Medium-normal';
import { PostRequest } from '../../../../common/api'
import { urls } from '../../../../common/constants'
import { getPartyVoucherListData } from '../../../../../store/Acounting/acounting_action'
import GenerateVchRowData from './GenerateVchRowData'
const GenerateVoucherTab = (props) => {
    const {
        data: { common }, updateAlertError, getPartyVoucherListData
    } = props
    const { translations } = useTranslation()
    const rdcn = translations?.rechargeDebitCreditNote || {}
    const cs = translations?.common || {}
    const transactionType = [
        { name: 'Booking', id: 1 },
        { name: 'Delivery', id: 2 },
    ]
    const columnDefs = getColumnDefs(translations)
    const columnDefsOneFilter = getColumnDefsOneFilter(translations)
    const columnDefsForGrouping = getColumnDefsForGrouping(translations)
    const { loginData } = common
    const [filters, setFilters] = useState({ fromDate: moment(new Date()), toDate: moment(new Date()), transactionType: '', partyCity: '', partyName: '', partyGSTN: '' })
    const [tableData, setTableData] = useState([])
    const [rowsPerPage, setRowsPerPage] = useState(50)
    const [page, setPage] = useState(0)
    const [isPdfLoaded, setIsPdfLoaded] = useState(false);
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [sourceCityList, setSourceCityList] = useState([])
    const [selSourceCity, setSelSourceCity] = useState([])
    const [sourceBranchList, setSourceBranchList] = useState([])
    const [selSourceBranch, setSelSourceBranch] = useState()
    const [resPartyCity, setResPartyCity] = useState([])
    const [updatedRes, setUpdatedRes] = useState([])
    const [selTransType, setSelTransType] = useState(transactionType[0])
    const [gstinNum, setGstinNum] = useState([])
    const [selGstinNum, setSelGstinNum] = useState([])
    // const [filteredData, setFilteredData] = useState([])
    // const [filterValues, setFilterValues] = useState({});

    const filterData = {
        // fromDate: moment(fromDate).format('DD-MM-YYYY'),
        // toDate: moment(toDate).format('DD-MM-YYYY'),
        voucherType: selTransType?.name,
        partyCity: selSourceCity?.CityName,
        partyName: selSourceBranch?.Party,
        PartyGSTIN: selGstinNum?.name
    }
    useEffect(() => {
        const partyCity = resPartyCity.flatMap((party) => {
            const cityIds = party.CityID.split("~");
            const cityNames = party.PartyCitiesNames.split("~");
            return cityIds.map((id, index) => ({
                PartyID: party.PartyID,
                Party: party.Party,
                CityID: id,
                CityName: cityNames[index] || "",
            }));
        });
        setUpdatedRes(partyCity)
        const gstinNumList = resPartyCity?.map(record => ({ id: record.GSTN, name: record.GSTN }))
        // .filter((val)=>val.id!=='')
        const gstinNumListData = removeDuplicatesFromArray(gstinNumList, 'id')
        setGstinNum(gstinNumListData)
        setSelGstinNum(gstinNumListData[0])
    }, [resPartyCity])
    useEffect(() => {
        const cities = updatedRes?.map(record => ({ CityID: record.CityID, CityName: record.CityName }));
        const cityList = removeDuplicatesFromArray(cities, 'CityID')
        const partyList = removeDuplicatesFromArray(updatedRes, 'PartyID')
        setSourceCityList([...cityList])
        setSourceBranchList([...partyList])
    }, [updatedRes])
    useEffect(() => {
        const loginCity = sourceCityList?.filter((val) => val?.CityID === loginData?.intBranchCityID)
        if (loginCity?.length > 0) {
            setSelSourceCity(loginCity[0])
        } else {
            setSelSourceCity(sourceCityList[0])
        }
    }, [sourceCityList])
    useEffect(() => {
        setSelSourceBranch(sourceBranchList[0])
    }, [sourceBranchList])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            const obj = {
                intPartyID: 0,
                intCompanyID: loginData.intCompanyID,
                strPartyName: "",
                strContactPerson: "",
                intCityID: 0,
                intIsCreditParty: -1,
                intIsActive: -1,
                intIsDeleted: 0
            }
            PostRequest(urls.getPartyList, obj).then((res) => {
                if (res.status === 'Success') {
                    setResPartyCity(res?.Data)
                }
            })
        }
    }, [loginData])
    const generatepdf = (isSave) => {
        try {
            setIsPdfLoaded(false);
            jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
            jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
            const doc = new jsPDF({
                orientation: 'p',
                format: [1240, 1754],
                unit: 'px',
                compress: true
            });
            const header1 = columnDefsOneFilter.map((item) => ({
                header: item.headerName, dataKey: item.field, xlCol: item.xlCol
            }))
            const hraderTableData = [filterData]
            const pdfColumnDefs = columnDefs.map((item) => ({
                header: item.headerName, dataKey: item.field, xlCol: item.xlCol
            }))
            doc.setProperties({
                title: `GenerateVoucher.pdf`,
                subject: rdcn.generateVoucher || 'Generate Voucher',
                author: 'Maven Tech Labs Pvt. Ltd.',
                keywords: 'maven tech, Cargo system, Generate Voucher',
                creator: 'MTLPL',
            })

            var totalPagesExp = '{total_pages_count_string}'
            const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {

                const doc = data.doc
                // Footer
                var pageSize = doc.internal.pageSize
                var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

                var str = 'Page : ' + doc.internal.getNumberOfPages()
                if (typeof doc.putTotalPages === 'function') {
                    str = str + ' of ' + totalPagesExp
                }
                doc.setFontSize(16)
                doc.text(str, doc.internal.pageSize.width - data.settings.margin.left, pageHeight - 5, "right")
                doc.setFont('Roboto', 'bold')
                doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
                doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
            }
            let newData = []
            tableData.forEach((val) => {
                if (val?.isRowData) {
                    newData.push(...val?.rowData)
                } else {
                    newData.push(val)
                }
            })
            autoTable(doc, {
                margin: { left: 30, right: 30, bottom: 5 },
                startY: 124,
                alternateRowStyles: {
                    fillColor: [255, 255, 255],
                },
                theme: 'grid',
                columns: header1,
                body: hraderTableData,
                headStyles: {
                    fillColor: [191, 225, 255],
                    textColor: [0, 0, 0],
                    minCellHeight: 36,
                    valign: 'middle',
                    cellPadding: 12,
                    fontSize: 16,
                    lineWidth: 0.6,
                    font: 'Roboto',
                    fontStyle: "normal"
                },
                columnStyles: {
                    0: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 295, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                    1: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 295, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                    2: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 295, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                    3: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 295, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                },
                didParseCell: function (data) {
                    if (data.row.index === 0) {
                        data.cell.styles.textColor = '#000000';
                    }
                },
                didDrawPage: function (data) {
                    jsPdfHeaderFooter(data, loginData, totalPagesExp);
                }
            })
            autoTable(doc, {
                margin: { top: 120, left: 30, right: 30, bottom: 60 },
                startY: doc.lastAutoTable.finalY + 24,
                alternateRowStyles: {
                    fillColor: [255, 255, 255],
                },
                theme: 'grid',
                columns: pdfColumnDefs,
                showHead: 'never',
                body: newData,
                tableLineWidth: 0.6,
                rowPageBreak: 'avoid',
                styles: {
                    lineWidth: [0, 0.6, 0, 0.6]
                },
                columnStyles: {
                    0: { cellWidth: 45, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding: 12 },
                    1: { cellWidth: 108.9, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding: 12 },
                    2: { cellWidth: 108.9, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding: 12 },
                    3: { cellWidth: 108.9, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding: 12 },
                    4: { cellWidth: 108.9, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding: 12 },
                    5: { cellWidth: 98.33, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding: 12 },
                    6: { cellWidth: 98.33, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding: 12 },
                    7: { cellWidth: 98.33, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding: 12 },
                    8: { cellWidth: 109, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding: 12 },
                    9: { cellWidth: 98.33, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding: 12 },
                    10: { cellWidth: 98.33, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding: 12 },
                    11: { cellWidth: 98.33, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding: 12 },
                },
                headStyles: {
                    fillColor: [191, 225, 255],
                    textColor: [0, 0, 0],
                    fontSize: 16,
                    minCellHeight: 36,
                    cellPadding: 12,
                    valign: 'top',
                    font: 'Roboto',
                    fontStyle: "normal"
                },
                didParseCell: function (data) {
                    jsPdfDidParseCellCallback(data, pdfColumnDefs, [])
                },
                willDrawCell: (data) => {
                    if (data.row.raw.isSubHeading) {
                        doc.setFillColor(191, 225, 255);
                        doc.setTextColor(0, 0, 0);
                        doc.setFontSize(16).setFont("Roboto", 'normal')
                        data.cell.styles.valign = 'middle';
                    }
                    else if (data.row.raw.isSubHeadingRow) {
                        doc.setFillColor(241, 249, 255);
                        doc.setTextColor(0, 0, 0);
                        doc.setFontSize(16).setFont("Roboto", 'normal')
                    } else if (data.row.raw.isTotalRow) {
                        doc.setFillColor(238, 238, 238);
                        doc.setTextColor(0, 0, 0);
                        doc.setFontSize(16).setFont("Roboto", 'normal')
                    } else if (data.row.raw.isPrintHeading) {
                        doc.setFillColor(191, 225, 255);
                        doc.setTextColor(0, 0, 0);
                        doc.setFontSize(16).setFont("Roboto", 'normal')
                    }
                },
                didDrawPage: function (data) {
                    doc.setTextColor(40)
                    doc.addImage('/images/logo-66.png', 'JPEG', 30, 40, 40, 40)
                    doc.setFontSize(26).setFont("Roboto", 'bold')
                    doc.setTextColor(16, 79, 162)
                    doc.text(`${rdcn.cargoSystemPartyVoucher || 'Cargo System | Party Voucher'} | ${rdcn.generateVoucher || 'Generate Voucher'}`, 30 + 60, 70)
                    doc.setTextColor(0, 0, 0)
                    doc.setFontSize(22).setFont("Roboto", 'normal')
                    doc.text(`${cs.companyName || 'Company Name'} :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 70, "right")
                    doc.setTextColor(0, 0, 0)
                    doc.setFontSize(20)
                    doc.setFont('Roboto', 'bold')
                    doc.text(`${rdcn.partyVoucher || 'Party Voucher'} : ${rdcn.generateVoucher || 'Generate Voucher'}`, 30, 110)
                    doc.setFontSize(20)
                    doc.setFont('Roboto', 'bold')
                    doc.text(`${rdcn.transactionDate || 'Transaction Date'}: ${moment(fromDate).format('DD-MM-YYYY')} To ${moment(toDate).format('DD-MM-YYYY')}`, doc.internal.pageSize.width - data.settings.margin.left, 110, 'right')
                    //   jsPdfHeaderFooter(data, loginData, totalPagesExp);
                }
            })
            doc.setFont('Roboto')
            if (typeof doc.putTotalPages === 'function') {
                doc.putTotalPages(totalPagesExp)
            }
            setIsPdfLoaded(true);
            // if (isSave) {
            // doc.save(`Cargo Unloading Report ${new Date().getTime()}.pdf`)
            setTimeout(() => {
                document.getElementById('GenerateVoucher').data = doc.output('datauristring', 'GenerateVoucher.pdf')
                focusElemnt('cuBackBtn')
            }, 1000)
            // } 
        } catch (err) {
            console.log(err)
            setIsPdfLoaded(false)
        }
    }
    const bodyData = [
        {
            "VoucherNo": 589,
            "BookingID": 27277949,
            "PartyName": "Bintu test",
            "VoucherDate": "2025-01-21T11:53:54",
            "NetAmount": 0,
            "LRNO": "MBGLR/24-25/1026",
            "LRDate": "20-Jan-25 02:34 PM",
            "GSTInv": "",
            "GSTDate": "",
            "GSTAmt": 0,
            "PaymentType": "ONACCOUNT",
            "TransactionType": "Booking",
            "GSTN": "..",
            "Outstanding": 0
        },
        {
            "VoucherNo": 589,
            "BookingID": 27277960,
            "PartyName": "Bintu test",
            "VoucherDate": "2025-01-21T11:53:54",
            "NetAmount": 0,
            "LRNO": "MBGLR/24-25/1027",
            "LRDate": "20-Jan-25 02:34 PM",
            "GSTInv": "",
            "GSTDate": "",
            "GSTAmt": 0,
            "PaymentType": "ONACCOUNT",
            "TransactionType": "Booking",
            "GSTN": "..",
            "Outstanding": 0
        },
        {
            "VoucherNo": 589,
            "BookingID": 27278463,
            "PartyName": "Bintu test",
            "VoucherDate": "2025-01-21T11:53:54",
            "NetAmount": 0,
            "LRNO": "MBGLR/24-25/1029",
            "LRDate": "20-Jan-25 03:13 PM",
            "GSTInv": "",
            "GSTDate": "",
            "GSTAmt": 0,
            "PaymentType": "ONACCOUNT",
            "TransactionType": "Booking",
            "GSTN": "..",
            "Outstanding": 0
        },
        {
            "VoucherNo": 590,
            "BookingID": 27278463,
            "PartyName": "Akash test",
            "VoucherDate": "2025-01-21T11:53:54",
            "NetAmount": 0,
            "LRNO": "MBGLR/24-25/1029",
            "LRDate": "20-Jan-25 03:13 PM",
            "GSTInv": "",
            "GSTDate": "",
            "GSTAmt": 0,
            "PaymentType": "ONACCOUNT",
            "TransactionType": "Booking",
            "GSTN": "..",
            "Outstanding": 0
        },
        {
            "VoucherNo": 590,
            "BookingID": 27278463,
            "PartyName": "Shubham test",
            "VoucherDate": "2025-01-21T11:53:54",
            "NetAmount": 0,
            "LRNO": "MBGLR/24-25/1029",
            "LRDate": "20-Jan-25 03:13 PM",
            "GSTInv": "",
            "GSTDate": "",
            "GSTAmt": 0,
            "PaymentType": "ONACCOUNT",
            "TransactionType": "Booking",
            "GSTN": "..",
            "Outstanding": 0
        },
    ]
    const groupData = (data) => {

        console.log("data", data)
        let voucherData = []
        let rowData = []
        let totalRow = {
            GSTAmt: 0,
            Outstanding: 0,
            NetAmount: 0
        }
        data.forEach((val, index) => {
            totalRow = {
                GSTAmt: Number(totalRow.GSTAmt) + Number(val.GSTAmt),
                Outstanding: Number(totalRow.Outstanding) + Number(val.Outstanding),
                NetAmount: Number(totalRow.NetAmount) + Number(val.NetAmount)
            }
            rowData.push({ ...val, SN: index + 1, isDataRow: true })
        })
        voucherData.push(
            { isSubHeadingRow: true, subHeadingData: [{ caption: `${(rdcn.voucherNo || 'Voucher No.').replace(/\n/g, ' ')}`, value: data[0].VoucherNo, colSpan: 6, align: 'left' }, { caption: `${(rdcn.voucherDate || 'Voucher Date').replace(/\n/g, ' ')} :`, value: moment(data[0].VoucherDate).format('DD-MMM-YYYY'), colSpan: 6, align: 'right' }] }
        )
        voucherData.push(
            { isSubHeading: true, ...columnDefsForGrouping }
        )
        voucherData.push({
            isRowData: true,
            rowData: rowData
        })
        voucherData.push({ isTotalRow: true, ...totalRow, caption: rdcn.totalUpper || 'TOTAL', colSpan: 9 })
        return voucherData
    }
    const handleGenerate = () => {
        if (moment(fromDate).format('YYYY-MM-DD') === moment(toDate).format('YYYY-MM-DD') || moment(fromDate).format('YYYY-MM-DD') > moment(toDate).format('YYYY-MM-DD') || moment(new Date()).format('DD-MM-YYYY') === moment(toDate).format('DD-MM-YYYY')) {
            updateAlertError({ show: true, msg: rdcn.cannotGenerateVoucherForCurrentDate || 'we can not generate voucher for current date', nextId: '' })
        } else {
            const body = {
                CompanyID: loginData.intCompanyID,
                BranchID: loginData.intBranchID,
                FromDate: moment(fromDate).format('YYYY-MM-DD'),
                Todate: moment(toDate).format('YYYY-MM-DD'),
                PartyCityID: selSourceCity?.CityID,
                PartyID: selSourceBranch?.PartyID,
                TransType: selTransType?.id === 1 ? 'B' : 'D',
                UserID: loginData.intUserID
            }
            getPartyVoucherListData(body).then((res) => {
                updateLoader(false)
                if (res.status === 'Success') {
                    // const data = bodyData?.map((val, index) => ({ ...val}));
                    // let groupedData = bodyData?.reduce((result, item) => {
                    let groupedData = res?.Data?.Table.reduce((result, item) => {
                        const key = `${item.VoucherNo}`
                        if (!result[key]) {
                            result[key] = []
                        } result[key].push(item)
                        return result
                    }, {})
                    let newData = []
                    Object.keys(groupedData).forEach((key) => {
                        const updateData = groupData(groupedData[key]);
                        newData = [...newData, ...updateData]
                    })
                    setTableData(newData || [])
                    // setFilteredData(newData || [])
                    // setTotalNoOfRows(2)
                    // setShowTable(true)
                } else {
                    updateAlertError({ show: true, msg: res?.Message, nextId: 'loadbtn' })
                    // setShowTable(false)
                }
            })
        }
    }
    const selectedCity = (val) => {
        setSelSourceCity(val)
        let result = updatedRes?.filter((obj) => obj.CityID === val.CityID || val?.CityID === 0 || obj.PartyID === 0)
        setSourceBranchList([...result])
    }
    return (
        <>
            <Grid container sx={{ display: 'flex', flexWrap: 'nowrap', gap: '16px', padding: '12px 15px 4px 15px' }}>
                <Grid item md={1.5}>
                    <Item sx={{ ...sx.itemsx }} className="input--container bookingDatePicker">
                        <Datepicker
                            label={rdcn.fromTxnDate || 'From Txn. Date'}
                            // name={'from_date'}
                            id={'fromDate'}
                            // value={fromDate}
                            dateChange={(date) => {
                                setFromDate(date)
                                focusElemnt('toDate')
                            }}
                            width="100%"
                        // startDate={'2022-01-01'}
                        // //startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
                        // endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date
                        />
                    </Item>
                </Grid>
                <Grid item md={1.5}>
                    <Item sx={{ ...sx.itemsx }} className="input--container bookingDatePicker">
                        <Datepicker
                            label={rdcn.toTxnDate || 'To Txn. Date'}
                            // name={'to_date'}
                            id={'toDate'}
                            // value={toDate}
                            dateChange={(date) => {
                                setToDate(date)
                                // focusElemnt(disableBtn ? id.creditTransSplitButton : id.stateId)
                            }}
                            width="100%"
                        // startDate={'2022-01-01'}
                        // //startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
                        // endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
                        />
                    </Item>
                </Grid>
                <Grid item md={1.5}>
                    <Item sx={{ ...sx.itemsx }} className="input--container">
                        <DropDownOA
                            id={'gv-transactionType'}
                            label={rdcn.transactionType || 'Transaction Type'}
                            data={transactionType}
                            defaultvalue={selTransType?.name}
                            // value={filters?.transactionType?.name}
                            onSelect={(val) => { setSelTransType(val) }}
                            // onReset={() => {
                            // }}
                            idKey={`id`}
                            dataKey={`name`}
                            nextId={``}
                            prevId={``}
                            width="100%"
                        />
                    </Item>
                </Grid>
                <Grid item md={1.5}>
                    <Item sx={{ ...sx.itemsx }} className="input--container">
                        <DropDownOA
                            id={'partyCity'}
                            label={(rdcn.partyCity || 'Party City').replace(/\n/g, ' ')}
                            data={sourceCityList}
                            defaultvalue={selSourceCity?.CityName}
                            idKey={`CityID`}
                            dataKey={`CityName`}
                            onSelect={(val) => {
                                selectedCity(val)
                            }}
                            isObjArr={true}
                            searchPlaceholder={rdcn.searchByPartyCity || 'Search By Party City'}
                            width="100%"
                        // nextId={id.srcBranch}
                        // prevId={id.stateId}
                        // resetFlag={resetFlag || resetCity}
                        // disabled={disableBtn}
                        />
                    </Item>
                </Grid>
                <Grid item md={1.5}>
                    <Item sx={{ ...sx.itemsx }} className="input--container">
                        <DropDownOA
                            id={'partyName'}
                            label={(rdcn.partyName || 'Party Name').replace(/\n/g, ' ')}
                            data={sourceBranchList}
                            defaultvalue={selSourceBranch?.Party || ''}
                            idKey={`PartyID`}
                            dataKey={`Party`}
                            onSelect={(val) => {
                                // setIsExpanded(false)
                                setSelSourceBranch(val)
                            }}
                            isObjArr={true}
                            searchPlaceholder={rdcn.searchByPartyName || 'Search By Party Name'}
                            width="100%"
                        // nextId={id.creditUsageSplitButton}
                        // prevId={id.srcCity}
                        // resetFlag={resetFlag || resetCity}
                        // disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
                        />
                    </Item>
                </Grid>
                {/* <Grid item md={1.5}>
                    <Item sx={{ ...sx.itemsx }} className="input--container">
                        <DropDownOA
                            id={'gv-partyGSTN'}
                            label={rdcn.partyGstn || 'Party GSTN'}
                            data={gstinNum}
                            defaultvalue={selGstinNum?.name}
                            // value={filters?.partyGSTN?.name}
                            onSelect={(val) => { setSelGstinNum(val) }}
                            // onReset={() => {
                            // }}
                            idKey={`id`}
                            dataKey={`name`}
                            nextId={``}
                            prevId={``}
                        />
                    </Item>
                </Grid> */}
                <Grid item md={1}>
                    <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
                        <Button
                            variant="contained"
                            onKeyDown={(e) => navigation3(e, 'cityPairSave_btn', 'destination_City', () => { })}
                            id={'load_Btn'}
                            sx={{ width: '100%', paddingY: '6px !important' }}
                            className="btn btn-primary"
                            onClick={handleGenerate}
                        >
                            {cs.generate || 'Generate'}
                        </Button>
                    </Item>
                </Grid>
                <Grid item md={1}>
                    <Item sx={{ ...sx.itemsx }} className="">
                        <Button
                            variant="outlined"
                            color="secondary"
                            id={'filterBtn'}
                            sx={{ width: '100%' }}
                            className="receiveitembtn"
                            onClick={() => {
                                generatepdf(false)
                            }}
                        >
                            {rdcn.printUpper || 'PRINT'}
                        </Button>
                    </Item>
                </Grid>
                <Grid item md={1}>
                    <Item sx={{ ...sx.itemsx }} className="">
                        <Button
                            variant="outlined"
                            color="secondary"
                            id={'exportBtn'}
                            sx={{ width: '100%' }}
                            className="receiveitembtn"
                            onClick={() => {
                                document.getElementById("test-table-xls-button").click();
                            }}
                        >
                            {rdcn.excel || 'EXCEL'}
                        </Button>
                        <ReactHtmlTableToExcel
                            id="test-table-xls-button"
                            className="hidden"
                            table="table-to-xls" // Make sure to set the correct table ID
                            filename={rdcn.generateVoucher || 'Generate Voucher'}
                            sheet="tablexls"
                            buttonText=""
                        />
                    </Item>
                </Grid>

            </Grid>
            {!isPdfLoaded ? (
                <Box sx={{ padding: '12px 15px 4px 15px' }}>
                    <TableContainer className='scrollBlue' component={Paper} style={{ marginBottom: '5px', maxHeight: '45vh' }}>
                        <Table
                            stickyHeader
                            size="small"
                            aria-label="a dense table"
                            sx={{
                                '&.MuiTableCell-root': {
                                    padding: '6px 8px!important',
                                },
                            }}
                        >
                            {tableData?.length > 0 ?
                                <TableBody>
                                    {(
                                        rowsPerPage > 0
                                            ? tableData.slice(
                                                page * rowsPerPage,
                                                page * rowsPerPage + rowsPerPage
                                            )
                                            : tableData
                                    ).map((val, index) => (
                                        <>
                                            {
                                                val.isSubHeadingRow ?
                                                    <>
                                                        <TableRow>
                                                            <TableCell colSpan={6} sx={{ height: '36px', fontSize: '14px', fontWeight: '700', color: '#444', backgroundColor: '#F1F9FF', padding: '6px', textAlign: 'left' }}>
                                                                {`${val?.subHeadingData[0]?.caption}:${val?.subHeadingData[0]?.value}`}
                                                            </TableCell>
                                                            <TableCell colSpan={6} sx={{ height: '36px', fontSize: '14px', fontWeight: '700', color: '#444', backgroundColor: '#F1F9FF', padding: '6px', textAlign: 'right' }}>
                                                                {`${val?.subHeadingData[1]?.caption} ${val?.subHeadingData[1]?.value}`}
                                                            </TableCell>
                                                        </TableRow>
                                                    </>
                                                    : val?.isRowData ?
                                                        <GenerateVchRowData data={val?.rowData} />
                                                        :
                                                        val.isSubHeading ?
                                                            <>
                                                                <TableRow>
                                                                    {columnDefs?.map((col, index) => (
                                                                        <TableCell key={`CityHeader-${index}`} sx={{
                                                                            ...col.headerSx,
                                                                            backgroundColor: '#DAEDFE',
                                                                            fontSize: '14px',
                                                                            fontWeight: '600',
                                                                            color: '#444',
                                                                            height: '36px',
                                                                            whiteSpace: 'pre',
                                                                            padding: '6px'
                                                                        }}>
                                                                            {col.headerName}
                                                                        </TableCell>
                                                                    ))}
                                                                </TableRow>

                                                            </>
                                                            : val.isTotalRow ?
                                                                <TableRow>
                                                                    <TableCell colSpan={9} sx={{ height: '36px', fontSize: '12px', fontWeight: '600', color: '#444', backgroundColor: '#EEEEEE', padding: '6px', textAlign: 'right' }}>
                                                                        {val?.caption}
                                                                    </TableCell>
                                                                    <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '600', color: '#444', backgroundColor: '#EEEEEE', padding: '6px', textAlign: 'right' }}>
                                                                        {val?.GSTAmt}
                                                                    </TableCell>
                                                                    <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '600', color: '#444', backgroundColor: '#EEEEEE', padding: '6px', textAlign: 'right' }}>
                                                                        {val?.Outstanding}
                                                                    </TableCell>
                                                                    <TableCell sx={{ height: '36px', fontSize: '12px', width: '4%', fontWeight: '600', backgroundColor: '#EEEEEE', color: '#444', padding: '6px', textAlign: 'right' }}>
                                                                        {val?.NetAmount}
                                                                    </TableCell>
                                                                </TableRow>
                                                                :
                                                                null
                                            }

                                        </>
                                    ))}
                                </TableBody> :
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={columnDefs?.length}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    marginTop: '20px',
                                                    marginBottom: '20px',
                                                    color: 'red',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                <span>{rdcn.noResultsFoundForFilters || 'No Results Found For The Selected Filters.'}</span>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>}
                        </Table>
                        <Table
                            id='table-to-xls'
                            stickyHeader
                            size="small"
                            aria-label="a dense table"
                            sx={{
                                '&.MuiTableCell-root': {
                                    padding: '6px 8px!important',
                                },
                                display: 'none'
                            }}
                        >
                            <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
                                <TableRow>
                                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }} colSpan={6}>
                                        <h3 style={{ paddingLeft: '17px' }}>{rdcn.reportGenerateVoucher || 'Report: Generate Voucher '}</h3>
                                    </TableCell>
                                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'right' }} colSpan={6}>
                                        <h3 style={{ paddingLeft: '17px' }}>{`${cs.companyName || 'Company Name'} : ${loginData.strCompanyName}`}</h3>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={columnDefs.length}></TableCell>
                                </TableRow>
                                <TableRow >
                                    {columnDefsOneFilter
                                        // .filter((_, index) => index <= 2)
                                        .map((val, index) => (
                                            <TableCell
                                                key={`FTR-${index}`}
                                                style={{
                                                    backgroundColor: '#BFE1FF',
                                                    fontSize: '18px',
                                                    fontWeight: '600',
                                                    textAlign: 'left',
                                                    color: '#444',
                                                }}
                                                colSpan={3}
                                            >
                                                {val.headerName}
                                            </TableCell>
                                        ))
                                    }
                                </TableRow>
                                <TableRow >
                                    <TableCell key={`FTR-partyCity`} style={{ fontSize: '18px', textAlign: 'left', fontWeight: "500", color: '#444' }} colSpan={3}>{selTransType?.name}</TableCell>
                                    <TableCell key={`FTR-fromDate`} style={{ fontSize: '18px', textAlign: 'left', fontWeight: "500", color: '#444' }} colSpan={3}>{selSourceCity?.CityName}</TableCell>
                                    <TableCell key={`FTR-toDate`} style={{ fontSize: '18px', textAlign: 'left', fontWeight: "500", color: '#444' }} colSpan={3}>{selSourceBranch?.Party}</TableCell>
                                    <TableCell key={`FTR-partyCity`} style={{ fontSize: '18px', textAlign: 'left', fontWeight: "500", color: '#444' }} colSpan={3}>{selGstinNum?.name}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={columnDefs.length}></TableCell>
                                </TableRow>
                            </TableHead>
                            {tableData?.length > 0 ? <TableBody>
                                {(
                                    rowsPerPage > 0
                                        ? tableData.slice(
                                            page * rowsPerPage,
                                            page * rowsPerPage + rowsPerPage
                                        )
                                        : tableData
                                ).map((val, index) => (
                                    <>
                                        {
                                            val.isSubHeadingRow ?
                                                <TableRow>
                                                    <TableCell colSpan={6} style={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', backgroundColor: '#F1F9FF', padding: '6px', textAlign: 'left' }}>
                                                        {`${val?.subHeadingData[0]?.caption}:${val?.subHeadingData[0]?.value}`}
                                                    </TableCell>
                                                    <TableCell colSpan={6} style={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', backgroundColor: '#F1F9FF', padding: '6px', textAlign: 'right' }}>
                                                        {`${val?.subHeadingData[1]?.caption} ${val?.subHeadingData[1]?.value}`}
                                                    </TableCell>
                                                </TableRow> : val?.isRowData ?
                                                    <GenerateVchRowData data={val?.rowData} />
                                                    : val.isSubHeading ?
                                                        <>
                                                            <TableRow>
                                                                {columnDefs?.map((col, index) => (
                                                                    <TableCell key={`CityHeader-${index}`} style={{
                                                                        ...col.headerSx,
                                                                        backgroundColor: '#DAEDFE',
                                                                        fontSize: '12px',
                                                                        fontWeight: '600',
                                                                        color: '#444',
                                                                        height: '36px',
                                                                        whiteSpace: 'pre',
                                                                        padding: '6px'
                                                                    }}>
                                                                        {col.headerName}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        </>
                                                        : val.isTotalRow ?
                                                            <TableRow>
                                                                <TableCell colSpan={9} style={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', backgroundColor: '#EEEEEE', padding: '6px', textAlign: 'right' }}>
                                                                    {val?.caption}
                                                                </TableCell>
                                                                <TableCell style={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', backgroundColor: '#EEEEEE', padding: '6px', textAlign: 'right' }}>
                                                                    {val?.GSTAmt}
                                                                </TableCell>
                                                                <TableCell style={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', backgroundColor: '#EEEEEE', padding: '6px', textAlign: 'right' }}>
                                                                    {val?.Outstanding}
                                                                </TableCell>
                                                                <TableCell style={{ height: '36px', fontSize: '12px', width: '12%', fontWeight: '500', backgroundColor: '#EEEEEE', color: '#444', padding: '6px', textAlign: 'right' }}>
                                                                    {val?.NetAmount}
                                                                </TableCell>
                                                            </TableRow>
                                                            :
                                                            <TableRow>
                                                                <TableCell style={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                                                                    {val?.SN}
                                                                </TableCell>
                                                                <TableCell style={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                                    {val?.LRNO}
                                                                </TableCell>
                                                                <TableCell style={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                                    {val?.LRDate}
                                                                </TableCell>
                                                                <TableCell style={{ height: '36px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                                    {val?.PartyName}
                                                                </TableCell>
                                                                <TableCell style={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                                    {val?.GSTN}
                                                                </TableCell>
                                                                <TableCell style={{ height: '36px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                                    {val?.PaymentType}
                                                                </TableCell>
                                                                <TableCell style={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                                    {val?.TransactionType}
                                                                </TableCell>
                                                                <TableCell style={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                                    {val?.GSTInv}
                                                                </TableCell>
                                                                <TableCell style={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                                    {val?.GSTDate}
                                                                </TableCell>
                                                                <TableCell style={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                                                                    {val?.GSTAmt}
                                                                </TableCell>
                                                                <TableCell style={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                                                                    {val?.Outstanding}
                                                                </TableCell>
                                                                <TableCell style={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                                                                    {val?.NetAmount}
                                                                </TableCell>
                                                            </TableRow>
                                        }

                                    </>
                                ))}
                            </TableBody> :
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={columnDefs?.length}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    marginTop: '20px',
                                                    marginBottom: '20px',
                                                    color: 'red',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                <span>{rdcn.noResultsFoundForFilters || 'No Results Found For The Selected Filters.'}</span>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>}
                        </Table>
                    </TableContainer>
                    <Box sx={{
                        'svg': {
                            color: 'inherit !important'
                        }
                    }}>
                        <TablePaginationCustom totRowCount={tableData?.length} rowsPerPageOptions={[10, 20, 50, 100, 200, 500]} rowsPerPage={rowsPerPage} page={page} handleChangePage={(event, newPage) => {
                            setPage(newPage)
                        }} handleChangeRowsPerPage={(event) => {
                            setRowsPerPage(parseInt(event.target.value, 10));
                            setPage(0);
                        }} />
                    </Box>
                </Box>) :
                <>
                    <Box style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', alignItems: 'center', padding: '10px 25px 5px 25px' }}>
                        <Button
                            id='cuBackBtn'
                            style={{
                                borderRadius: '5px',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                fontSize: '15px',
                                color: '#fe5200',
                                background: 'white',
                                marginLeft: '620px',
                                border: '2px solid #fe5200',
                            }}
                            onClick={() => setIsPdfLoaded(false)}
                        >
                            {cs.back || 'Back'}
                        </Button>
                    </Box>

                    <Box sx={{ marginLeft: 2, marginRight: 1.5, height: 430, paddingTop: '10px' }} >
                        <object
                            id="GenerateVoucher"
                            type="application/pdf"
                            width={"100%"}
                            height="440vh"
                            title="MTLPL - Generate Voucher"
                            aria-label="MTLPL - CARGO - Cargo Unloading Report"
                        >

                        </object>
                    </Box>
                </>
            }
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateAlertError, getPartyVoucherListData }
export default connect(mapStateToProps, mapDispatchToProps)(GenerateVoucherTab)
